module.exports = __webpack_public_path__ + "static/media/colorbar.41b843eb.jpg";